import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link'
import React from 'react';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import { faSyringe } from '@fortawesome/free-solid-svg-icons';

const Referral = (props) => {
  return (
    <div className={classnames(component)}>
      <div>
        
        <ul>
        
            <li>
            <Link href='/vaccination-rollout-and-access'>
              <a>
                <span className='icon'>
                  <FontAwesomeIcon icon={faSyringe} />
                </span>
                <span className='text'>
                  <strong>See our new vaccination tracker</strong> <br />
                  With the latest statistics and information including vaccination eligibility from governments and health authorities around the world 
                </span>
                </a>
                </Link>
            </li>
            
        </ul>
        
      </div>
    </div>
  );
};

export default Referral;
